import { Component, Injector, OnInit, Renderer2, ElementRef, AfterViewInit } from '@angular/core';
import { BaseComponent } from '../common/BaseComponent';
import { TranslateService } from '@ngx-translate/core';

import {
  ActivatedRoute,
  Router,
  NavigationEnd,
  RoutesRecognized,
  Params,
} from '@angular/router';
import { filter, pairwise } from 'rxjs';
import { Subscription } from 'rxjs';
interface AccordionSection {
  name: string;
  title: string;
  items: AccordionItem[];
}

interface AccordionItem {
  title: string;
  content: string;
}
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styles: [
    `
      .ontario-margin-bottom {
        margin-bottom: 2.5rem;
      }
      .link-to-home{
        font-size:17px;
      }
    `,
  ],
})
export class HelpComponent extends BaseComponent implements OnInit {
  expanded: boolean = false;
  showMyContainer: boolean = true;
  // helpKey: string = '';
  // previousUrl: string;
  private languageChangeSubs: Subscription;
  constructor(injector: Injector, private translate: TranslateService,
    private elementRef: ElementRef) {
    super(injector);
  }

  ngOnInit(): void {
    // reading quesry parameters
    // this.route.queryParams.subscribe((query: Params) => {
    //     console.log(query);
    //     this.previousUrl = query['id'];
    //   });

    // if (this.previousUrl === '/public/login') {
    // this.helpKey = "section1";
    // }
    // else if (this.previousUrl === '/public/register') {
    //     this.helpKey = "section2";
    // }
    // else if (this.previousUrl === '/secure/profile') {
    //     this.helpKey = "section3";
    // }
    // else if (this.previousUrl === '/secure/roles') {
    //     this.helpKey = "section4";
    // }
    this.initVisibilityState();
    this.subscribeToLanguageChange();
  }

  accordionSections: AccordionSection[] = [];
  isContentVisible: boolean[][] = [];
  private subscribeToLanguageChange(): void {
    this.languageChangeSubs = this.translate.onLangChange.subscribe(
      () => {
        this.initVisibilityState();
      }
    );
  }
  toggleContent(sectionIndex: number, itemIndex: number) {
    this.isContentVisible[sectionIndex][itemIndex] =
      !this.isContentVisible[sectionIndex][itemIndex];
  }

  // getHelpContent(index:number) {
  //     this.isContentVisible[index][0] = true;
  // }

  initVisibilityState() {
    this.translate
      .get('accordionSections')
      .subscribe((translatedSections: AccordionSection[]) => {
        this.accordionSections = translatedSections;
        this.accordionSections.forEach((section) => {
          const sectionVisibility: boolean[] = [];
          section.items.forEach(() => {
            sectionVisibility.push(false);
          });
          this.isContentVisible.push(sectionVisibility);
          // this.getHelpContent(this.helpKey);
        });
      });
  }
  expandAll(sectionIndex: number) {
    const sectionVisibility = this.isContentVisible[sectionIndex];
    const isAllExpanded = sectionVisibility.every((item) => item);
    this.isContentVisible[sectionIndex] = sectionVisibility.map(
      () => !isAllExpanded
    );
  }
  buttonText(sectionIndex:number):string {
    const translateExpandButton = this.isAllExpanded(sectionIndex)? 'bss.help.collapse':'bss.help.expand';
    return this.translate.instant(translateExpandButton);
  }
  isAllExpanded(sectionIndex: number): boolean {
    const sectionVisibility = this.isContentVisible[sectionIndex];
    return sectionVisibility.every((item) => item);
  }
  ngOnDestroy() {
    if (this.languageChangeSubs) {
      this.languageChangeSubs.unsubscribe();
    }
  }
  onHome() {
    this.router.navigate(['/public/login']);
  }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.querySelector('h2').focus();
  }
}
